import { BaseModal2 } from '../../../shared/view/BaseModal2/BaseModal2';
import { Prototype } from '../../../shared/view/BaseView';
import { FarmModel } from '../../../shared/model/farms/FarmModel';
import {FARMS} from '../../../js/resources/SessionObjects';

/**
 * @class FarmAddModal
 * @extends BaseModal2
 */
@Prototype({
})
export class FarmAddModal extends BaseModal2 {

    initialize (options) {

        this.onSave = this.onSave.bind(this);
        
        const modelTargetKey = 'name';

        this.model = new FarmModel();
        
        const origValidateProp = this.model.validateProperty;
        this.model.validateProperty = (property, attributes, opt) => {

            const validationError = origValidateProp(property, attributes, opt);
            
            if(validationError) return validationError;

            if(options.collection.models.find(farm => farm.attributes[modelTargetKey].trim() === this.model.attributes[modelTargetKey].trim())) {
                return {
                    property: modelTargetKey,
                    message: __('FARM_ALREADY_PRESENT'),
                }
            }
        };

        const superOptions = {
            title: __('FARM_CREATE_TITLE'),
            sections: [
                {
                    type: 'TEXT',
                    content: __('FARM_CREATE_CONTENT'),
                    size: 'small',
                },
                {
                    type: 'INPUT',
                    model: this.model,
                    modelTargetKey,
                    modelValidation: true,
                    width: '100%',
                },
            ],
            destroyWith: this,
            buttons: [
                {
                    label: __('CANCEL'),
                    type: 'PRIMARY',
                    callback: () => {
                        this.destroy();
                    }
                },
                {
                    label: __('SAVE'),
                    type: 'ACTION',
                    model: this.model,
                    modelTargetKey,
                    callback: this.onSave,
                    disabled: true,
                },
            ]
        };

        super.initialize(superOptions);
        this.options = _.extend(this.options, options);
    }

    onSave() {

        const farm = this.model;

        return farm.save()
            .done(() => {

                farm.ensureAccess()
                    .done((farmPermissions) => {

                        Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                            content: __('FARM_SAVED'),
                            isMessage: true
                        });

                        farm.set({isOwnFarm: true});

                        FARMS.add(farm);

                        this.options.onDone && this.options.onDone(farm, farmPermissions);
                    })
                    .fail(() => {

                        Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                            content: __('SMTH_WRONG'),
                            autoCloseTime: 5000
                        });
                    })
            })
            .fail(() => {
                
                Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                    content: __('FARM_SAVE_FAILED')
                });
            })
            .always(() => {

                this.destroy();
            })
    }
}



// WEBPACK FOOTER //
// ./layout/FarmLayout/FarmAddModal/FarmAddModal.js